import { AxiosRequestConfig } from "axios";
import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { toSlug } from "../../../shared/utils";
import { ContasAReceberFormData } from "../schema/criar-contas-a-receber.schema";
import { EditarContasAReceberFormData } from "../schema/editar-contas-a-receber.schema";
import { LiquidarContasReceberFormData } from "../schema/liquidar-conta-a-receber.schema";


const criar = async (data: ContasAReceberFormData, config?: AxiosRequestConfig<any> | undefined): Promise<void> => {
    try {
        const response = await baseApiService.post('/accounts-receivable', data, config);
        return response.data.data.id;
    } catch (err) {
        throw errosHandler(err);
    }
};

const deletar = async (id: string): Promise<string> => {
    try {
        const response = await baseApiService.delete(`/accounts-receivable/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/accounts-receivable/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const editar = async (id: string, data: EditarContasAReceberFormData): Promise<void> => {
    try {
        await baseApiService.put(`/accounts-receivable/${id}`, data);
    }
    catch (err) {
        throw errosHandler(err);
    }
};

const liquidar = async (id: string, data: LiquidarContasReceberFormData): Promise<void> => {
    try {
        await baseApiService.post(`/accounts-receivable/liquidate/${id}`, data);
    }
    catch (err) {
        throw errosHandler(err);
    }
};

const findAll = async (filtro?: string, pagina = 0, limite = 10, campo?: string): Promise<{ items: any[]; totalItems: number }> => {
    try {
        const filtroPesquisa = filtro?.trim() ? toSlug(filtro) : "";
        const query = filtroPesquisa
            ? `/accounts-receivable?page=${pagina + 1}&limit=${limite}&campo_pesquisa=slug&tipo_pesquisa=in&valor_pesquisa=${filtroPesquisa}`
            : `/accounts-receivable?page=${pagina + 1}&limit=${limite}`;
        const result = await baseApiService.get(query);
        const responseData = result.data?.data;
        return {
            items: Array.isArray(responseData?.items) ? responseData.items : [],
            totalItems: responseData?.meta?.totalItems || 0,
        };
    } catch (error) {
        console.error("Erro ao buscar empresas:", error);
        throw errosHandler(error);
    }
};



export const contasAReceberService = {
    criar,
    deletar,
    detalhar,
    editar,
    findAll,
    liquidar,
};

